import { EstimateType } from "src/generated/graphqlTypes";
import { EstimatePageQuery } from "src/routes/projects/estimates/EstimatePage.generated";
export function createContractDisabledReason(estimate: EstimatePageQuery["projectEstimate"]): string | undefined {
  const isChangeOrderEstimate = estimate.changeEvent?.id !== undefined;
  const projectStage = estimate.projectStage;
  return estimate.type.code === EstimateType.Preliminary
    ? "Only final estimates can create contracts"
    : projectStage.hasSignedContract && !isChangeOrderEstimate
      ? "Stage already has a prime contract"
      : undefined;
}
